import React, { FC } from 'react';
import { Label, Score } from './Atoms';
import { useTranslation } from 'react-i18next';

type Props = {
  score: number;
  maxScore: number;
  scoredAtDate: string;
};

const ScoreSummaryContent: FC<Props> = ({ score, maxScore, scoredAtDate }) => {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <Label>{t('trajectory.sections.shared.answers.date')}: </Label>
        {scoredAtDate}
      </div>
      <div>
        <Label>{t('trajectory.sections.shared.answers.score')}: </Label>
        <Score className={score / maxScore < 0.5 ? 'warning' : undefined}>
          {score}/{maxScore}
        </Score>
      </div>
    </>
  );
};

export default ScoreSummaryContent;
